import StyledTextField from '@shared/components/core/field/StyledTextField';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

/** NOTE: not included in ControlTypeField */

function DictationControlField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    return (
        <StyledTextField
            disabled={disabled}
            fullWidth
            value={value}
            label={t('common:dictation.title')}
            placeholder={t('common:dictation.question')}
            onChange={(e) => onChange(e.target.value)}
        />
    );
}

export default DictationControlField;
